import { cloneElement } from 'react';
import { Text, type TextProps } from '@doist/marketist';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import { ProductUITaskCircle, type ProductUITaskCircleProps } from '../product-ui-task-circle/product-ui-task-circle';
import css from './product-ui-task-calendar-month.module.css';
export type ProductUITaskCalendarMonthProps = {
  taskCircle: React.ReactNode;
  text: React.ReactNode;
  dateComponent?: React.ReactNode;
  icon?: React.ReactElement;
  state?: 'hovered' | 'idle';
};
export function ProductUITaskCalendarMonth({
  taskCircle,
  text,
  dateComponent,
  icon,
  state
}: ProductUITaskCalendarMonthProps) {
  const Icon = icon ? cloneElement(icon, {
    width: 18,
    height: 18
  }) : null;
  return <div className={cn(css.taskCalendarMonth, state ? css[state] : null)} data-sentry-component="ProductUITaskCalendarMonth" data-sentry-source-file="product-ui-task-calendar-month.tsx">
            <div className={css.left}>
                {taskCircle}
                {text}
            </div>
            <div className={css.right}>
                {dateComponent}
                {Icon}
            </div>
        </div>;
}
ProductUITaskCalendarMonth.TaskCircle = function ProductUITaskCalendarMonthTaskCircle({
  futureOccurrence,
  ...rest
}: ProductUITaskCircleProps & {
  futureOccurrence?: boolean;
}) {
  return <ProductUITaskCircle variant="calendar" hasFutureOccurrence={futureOccurrence} {...rest} />;
};
ProductUITaskCalendarMonth.Text = function ProductUITaskCalendarMonthText({
  text,
  ...rest
}: TextProps & {
  text: string;
}) {
  return <Text tag="div" size="body-2xs" className={css.text} {...rest}>
            {text}
        </Text>;
};
ProductUITaskCalendarMonth.Date = function ProductUITaskCalendarMonthDate({
  date,
  ...rest
}: TextProps & {
  date: Date;
}) {
  const {
    i18n
  } = useTranslation('product-ui');
  const showMinutes = date.getMinutes() > 0;
  return <Text tag="div" size="body-2xs" className={css.date} {...rest}>
            {date.toLocaleTimeString(i18n.language, {
      hour: 'numeric',
      minute: showMinutes ? 'numeric' : undefined
    })}
        </Text>;
};